import React from 'react'
import { ReactComponent as Anim } from 'assets/images/dots-anim.svg'
import { Container } from './Styled'

export const LogoAnim: React.FC = () => (
  <Container>
    <Anim />
  </Container>
)
